var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenthunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_36795",
    "data-name": "Group 36795",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c8de650469656fb4140ed951f82197e9",
    d: "M41.842,38.895l-6.681-.4a.447.447,0,0,0-.37.739l1.677,2.075a.446.446,0,0,1-.057.625L31.494,45.86a.448.448,0,0,1-.625-.057l-2.075-2.388-.625-.711a.45.45,0,0,0-.625-.057l-.654.54-7.875,6.766a.473.473,0,0,0-.085.6.455.455,0,0,0,.6.142l7.562-4.321a.47.47,0,0,1,.569.085l2.274,2.587.625.711a.478.478,0,0,0,.625.057l.739-.6L38.2,44.126a.446.446,0,0,1,.625.057l1.677,2.075a.448.448,0,0,0,.8-.227l1-6.624A.5.5,0,0,0,41.842,38.895Z",
    transform: "translate(-18.579 -32.623)",
    fill: "#43d96f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenthunder);
export default __webpack_public_path__ + "static/media/greenthunder.ff74111b9b405fc3cd64e0931a74348e.svg";
export { ForwardRef as ReactComponent };